export const uploadFileToPresignedUrl = async (
  file: File,
  presignedUrl: string,
  signal?: AbortSignal
): Promise<boolean> => {
  try {
    const response = await fetch(presignedUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type
      },
      signal
    });

    if (!response.ok) {
      return false;
    }
    return true;
  } catch (error) {
    if (error instanceof DOMException && error.name === 'AbortError') {
      throw error;
    }
    return false;
  }
};
